import Vue from "vue";
import "../assets/theme/index.css";
import $Cookies from "js-cookie";
import { Ajax as $Ajax, MD5 as $MD5, baseURL as $BaseURL } from "@/ajax";
import {
  dateFormat as $DateFormat,
  queryString as $QueryString,
} from "riku-verycloud";
import $RModal from "@/modal";
const plugins = {
  install(Vue, options = {}) {
    Object.assign(Vue.prototype, {
      $Ajax,
      $MD5,
      $BaseURL,
      $DateFormat,
      $QueryString,
      $Cookies,
      $RModal,
    });
  },
};

import {
  Tree,
  Message,
  Input,
  Button,
  InfiniteScroll,
  Checkbox,
  Form,
  FormItem,
  Select,
  Option,
  Radio as ERadio,
  RadioGroup as ERadioGroup,
  Loading
} from "element-ui";
import {
  CountDown,
  Field,
  Icon,
  Tabbar,
  TabbarItem,
  Overlay,
  Empty,
  SwipeCell,
  Button as VButton,
  Dialog,
  Toast,
  PullRefresh,
  Lazyload,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  Divider,
  NoticeBar,
  RadioGroup,
  Radio,
  CellGroup,
  Cell,
  Popover,
  Search,
  Uploader,
  Form as VForm,
  List,
  Stepper,
  Popup,
  Loading as VLoading,
  ImagePreview,
  IndexBar,
  IndexAnchor,
  Image as VanImage,
  Slider,
  PasswordInput,
  NumberKeyboard,
  Switch
} from "vant";
Vue.use(Tree);
Vue.use(Input);
Vue.use(Button);
Vue.use(InfiniteScroll);
Vue.use(Checkbox);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(ERadio);
Vue.use(ERadioGroup);
Vue.use(Loading);

Vue.use(CountDown);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Overlay);
Vue.use(Empty);
Vue.use(SwipeCell);
Vue.use(VButton);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(PullRefresh);
Vue.use(Lazyload);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Divider);
Vue.use(NoticeBar);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Popover);
Vue.use(Search);
Vue.use(Uploader);
Vue.use(VForm);
Vue.use(List);
Vue.use(Stepper);
Vue.use(Popup);
Vue.use(VLoading);
Vue.use(ImagePreview);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(VanImage);
Vue.use(Slider)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Switch)

Vue.prototype.$Message = Message;

// // 下拉框加载更多
// Vue.directive('loadmore', {
//   bind (el, binding, vnode) {
//     const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
//     SELECTWRAP_DOM.addEventListener('scroll', function () {
//       const CONDITION = (this.scrollHeight - this.scrollTop) - 15 <= this.clientHeight
//       if (CONDITION) {
//         binding.value()
//       }
//     })
//   }
// })

Vue.directive("numberOnly", {
  bind: function (el) {
    el.handler = function () {
      el.childNodes[1].value = el.childNodes[1].value.replace(/\D+/g, ""); //因为是elementui组件里使用的el.value获取不到我们输入的内容。然后我发现他的第一个孩子才是我们输入的手机号码的内容。
    };
    el.addEventListener("keyup", el.handler); //这里使用keyup。我开始用的input发现第一次输入拼音字母竟然是可以输入的。改成keyup就都不能输入非数字了
  },
  unbind: function (el) {
    el.removeEventListener("keyup", el.handler);
  },
});
Vue.directive("int", {
  inserted: function (el) {
    el.addEventListener("keypress", function (e) {
      e = e || window.event;
      let charcode = typeof e.charCode == "number" ? e.charCode : e.keyCode;
      let re = /\d/;
      if (
        !re.test(String.fromCharCode(charcode)) &&
        charcode > 9 &&
        !e.ctrlKey
      ) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  },
});
Vue.directive("loadmore", {
  bind(el, binding, vnode) {
    const SELECTWRAP_DOM = el.querySelector(
      ".el-select-dropdown .el-select-dropdown__wrap"
    );
    SELECTWRAP_DOM.addEventListener("scroll", function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (CONDITION) {
        binding.value();
      }
    });
  },
});
Vue.directive('focus',{
  inserted:function(el){
    el.querySelector('input').focus()
  }
})
 //自定义指令 ,只能输入字母和数字
 Vue.directive('Alphabet', {
  inserted: function (el) {
    const input = el.querySelector('#valueInput');
    input.onkeyup = function (e) {
      input.value = input.value.replace(/[^A-Za-z0-9]/g, '')
    }
    input.onblur = function (e) {
      input.value = input.value.replace(/[^A-Za-z0-9]/g, '')
    }
  }
});
export default plugins;
